export default "__VITE_ASSET__DUbl0btq__"